import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import SurveyResponseEndpoint from '../../../api/endpoint/SurveyResponseEndpoint';
import Spinner from 'react-bootstrap/esm/Spinner';
import { useLocation, useNavigate } from 'react-router';

export const Survey = () => {
    const [q1Response, setQ1Response] = useState(0);
    const [q2Response, setQ2Response] = useState(0);
    const [q3Response, setQ3Response] = useState(0);
    const [q4Response, setQ4Response] = useState(0);
    const [q5Response, setQ5Response] = useState(0);
    const [q6Response, setQ6Response] = useState(0);

    const [q7Response, setQ7Response] = useState(0);

    const [q8Response, setQ8Response] = useState(0);

    const [shortResponse1, setShortResponse1] = useState('');
    const [shortResponse2, setShortResponse2] = useState('');
    const [shortResponse3, setShortResponse3] = useState('');
    const [shortResponse4, setShortResponse4] = useState('');
    const [shortResponse5, setShortResponse5] = useState('');

    const [validated, setValidated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const location = useLocation();
    const navigate = useNavigate();

    const handleSubmit = async (event: any) => {
        const urlParams = new URLSearchParams(location.search);

        const hash = urlParams.get('user');
        const courseEventId = urlParams.get('course');

        try {
            setIsLoading(true);

            if (!hash || hash === '') {
                throw new Error('unable to retrieve user email.');
            }

            if (!courseEventId || courseEventId === '') {
                throw new Error('unable to retrieve course event.');
            }

            const form = event.currentTarget;

            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
                setErrMsg('');
                await new Promise((resolve) => setTimeout(resolve, 50));
                setTimeout(() => {}, 500);
                throw new Error('Please answer all multiple choice questions.')
            }

            else if (form.checkValidity() === true) {
                event.preventDefault();
                const submitResult = await SurveyResponseEndpoint.Submit({
                    course_event_id: courseEventId,
                    email_hash: hash,
                    scaled_response_q1: q1Response,
                    scaled_response_q2: q2Response,
                    scaled_response_q3: q3Response,
                    scaled_response_q4: q4Response,
                    scaled_response_q5: q5Response,
                    scaled_response_q6: q6Response,
                    scaled_response_q7: q7Response,
                    scaled_response_q8: q8Response,
                    short_response_q1: shortResponse1,
                    short_response_q2: shortResponse2,
                    short_response_q3: shortResponse3,
                    short_response_q4: shortResponse4,
                    short_response_q5: shortResponse5,
                });

                if (submitResult.errors && submitResult.errors.length > 0) {
                    throw new Error(submitResult.errors.join(', '));
                }
                setTimeout(() => navigate('/survey/success', { state: { key: Date.now() } }), 0);
            }

            setIsLoading(false);
            setValidated(true);
        }
        catch (err) {
            setIsLoading(false);
            setErrMsg('Error: ' + (err instanceof Error ? err.message : String(err)));
        }
    };

    return (
        <div>
            <h1 className="text-light">Survey Responses Entry</h1>
            <hr className="border"/>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <div style={{ padding: "2em 1.5em", backgroundColor: "white", borderRadius: "0.5em", marginBottom: "1.5em" }}>
                    <Table responsive style={{width:"100%", borderColor:"#cdcdcd"}}>
                        <thead>
                            <tr className='text-center'>
                                <td className="w-auto"></td>
                                <th style={{width:"18%"}}>Strongly Agree</th>
                                <th style={{width:"18%"}}>Agree</th>
                                <th style={{width:"18%"}}>Disagree</th>
                                <th style={{width:"18%"}}>Strongly Disagree</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th><span>The class session was well-organized</span></th>
                                <td className="text-center">
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q1-strongly-agree"
                                        value={4}
                                        name="q1"
                                        checked={q1Response === 4}
                                        onChange={(e: any) => setQ1Response(Number(e.target.value))}
                                        aria-label="Question 1 Strongly Agree"
                                        feedback="You must select an option before submitting."
                                        feedbackType="invalid"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q1-agree"
                                        value={3}
                                        name="q1"
                                        checked={q1Response === 3}
                                        onChange={(e: any) => setQ1Response(Number(e.target.value))}
                                        aria-label="Question 1 Agree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q1-strongly-agree"
                                        value={2}
                                        name="q1"
                                        checked={q1Response === 2}
                                        onChange={(e: any) => setQ1Response(Number(e.target.value))}
                                        aria-label="Question 1 Disagree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q1-strongly-disagree"
                                        value={1}
                                        name="q1"
                                        checked={q1Response === 1}
                                        onChange={(e: any) => setQ1Response(Number(e.target.value))}
                                        aria-label="Question 1 Strongly Disagree"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th><span>The instructor presented the subject matter clearly</span></th>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q2-strongly-agree"
                                        value={4}
                                        name="q2"
                                        checked={q2Response === 4}
                                        onChange={(e: any) => setQ2Response(Number(e.target.value))}
                                        aria-label="Question 2 Strongly Agree"
                                        feedback="You must select an option before submitting."
                                        feedbackType="invalid"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q2-agree"
                                        value={3}
                                        name="q2"
                                        checked={q2Response === 3}
                                        onChange={(e: any) => setQ2Response(Number(e.target.value))}
                                        aria-label="Question 2 Agree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q2-disagree"
                                        value={2}
                                        name="q2"
                                        checked={q2Response === 2}
                                        onChange={(e: any) => setQ2Response(Number(e.target.value))}
                                        aria-label="Question 2 Disagree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q2-strongly-disagree"
                                        value={1}
                                        name="q2"
                                        checked={q2Response === 1}
                                        onChange={(e: any) => setQ2Response(Number(e.target.value))}
                                        aria-label="Question 2 Strongly Disagree"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th><span>The class content was pertinent to my job</span></th>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q3-strongly-agree"
                                        value={4}
                                        name="q3"
                                        checked={q3Response === 4}
                                        onChange={(e: any) => setQ3Response(Number(e.target.value))}
                                        aria-label="Question 3 Strongly Agree"
                                        feedback="You must select an option before submitting."
                                        feedbackType="invalid"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q3-agree"
                                        value={3}
                                        name="q3"
                                        checked={q3Response === 3}
                                        onChange={(e: any) => setQ3Response(Number(e.target.value))}
                                        aria-label="Question 3 Agree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q3-disagree"
                                        value={2}
                                        name="q3"
                                        checked={q3Response === 2}
                                        onChange={(e: any) => setQ3Response(Number(e.target.value))}
                                        aria-label="Question 3 Disagree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q3-strongly-disagree"
                                        value={1}
                                        name="q3"
                                        checked={q3Response === 1}
                                        onChange={(e: any) => setQ3Response(Number(e.target.value))}
                                        aria-label="Question 3 Strongly Disagree"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th><span>The presentation was clear and understandable</span></th>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q4-strongly-agree"
                                        value={4}
                                        name="q4"
                                        checked={q4Response === 4}
                                        onChange={(e: any) => setQ4Response(Number(e.target.value))}
                                        aria-label="Question 4 Strongly Agree"
                                        feedback="You must select an option before submitting."
                                        feedbackType="invalid"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q4-agree"
                                        value={3}
                                        name="q4"
                                        checked={q4Response === 3}
                                        onChange={(e: any) => setQ4Response(Number(e.target.value))}
                                        aria-label="Question 4 Agree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q4-disagree"
                                        value={2}
                                        name="q4"
                                        checked={q4Response === 2}
                                        onChange={(e: any) => setQ4Response(Number(e.target.value))}
                                        aria-label="Question 4 Disagree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q4-strongly-disagree"
                                        value={1}
                                        name="q4"
                                        checked={q4Response === 1}
                                        onChange={(e: any) => setQ4Response(Number(e.target.value))}
                                        aria-label="Question 4 Strongly Disagree"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th><span>The instructor was well-prepared</span></th>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q5-strongly-agree"
                                        value={4}
                                        name="q5"
                                        checked={q5Response === 4}
                                        onChange={(e: any) => setQ5Response(Number(e.target.value))}
                                        aria-label="Question 5 Strongly Agree"
                                        feedback="You must select an option before submitting."
                                        feedbackType="invalid"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q5-agree"
                                        value={3}
                                        name="q5"
                                        checked={q5Response === 3}
                                        onChange={(e: any) => setQ5Response(Number(e.target.value))}
                                        aria-label="Question 5 Agree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q5-disagree"
                                        value={2}
                                        name="q5"
                                        checked={q5Response === 2}
                                        onChange={(e: any) => setQ5Response(Number(e.target.value))}
                                        aria-label="Question 5 Disagree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q5-strongly-disagree"
                                        value={1}
                                        name="q5"
                                        checked={q5Response === 1}
                                        onChange={(e: any) => setQ5Response(Number(e.target.value))}
                                        aria-label="Question 5 Strongly Disagree"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th><span>The instructor encouraged questions</span></th>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q6-strongly-agree"
                                        value={4}
                                        name="q6"
                                        checked={q6Response === 4}
                                        onChange={(e: any) => setQ6Response(Number(e.target.value))}
                                        aria-label="Question 6 Strongly Agree"
                                        feedback="You must select an option before submitting."
                                        feedbackType="invalid"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q6-agree"
                                        value={3}
                                        name="q6"
                                        checked={q6Response === 3}
                                        onChange={(e: any) => setQ6Response(Number(e.target.value))}
                                        aria-label="Question 6 Agree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q6-disagree"
                                        value={2}
                                        name="q6"
                                        checked={q6Response === 2}
                                        onChange={(e: any) => setQ6Response(Number(e.target.value))}
                                        aria-label="Question 6 Disagree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q6-strongly-disagree"
                                        value={1}
                                        name="q6"
                                        checked={q6Response === 1}
                                        onChange={(e: any) => setQ6Response(Number(e.target.value))}
                                        aria-label="Question 6 Strongly Disagree"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th><span>The course materials were useful</span></th>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q7-strongly-agree"
                                        value={4}
                                        name="q7"
                                        checked={q7Response === 4}
                                        onChange={(e: any) => setQ7Response(Number(e.target.value))}
                                        aria-label="Question 7 Strongly Agree"
                                        feedback="You must select an option before submitting."
                                        feedbackType="invalid"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q7-agree"
                                        value={3}
                                        name="q7"
                                        checked={q7Response === 3}
                                        onChange={(e: any) => setQ7Response(Number(e.target.value))}
                                        aria-label="Question 7 Agree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q7-disagree"
                                        value={2}
                                        name="q7"
                                        checked={q7Response === 2}
                                        onChange={(e: any) => setQ7Response(Number(e.target.value))}
                                        aria-label="Question 7 Disagree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q7-strongly-disagree"
                                        value={1}
                                        name="q7"
                                        checked={q7Response === 1}
                                        onChange={(e: any) => setQ7Response(Number(e.target.value))}
                                        aria-label="Question 7 Strongly Disagree"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th><span>The class examples helped clarify the instruction</span></th>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q8-strongly-agree"
                                        value={4}
                                        name="q8"
                                        checked={q8Response === 4}
                                        onChange={(e: any) => setQ8Response(Number(e.target.value))}
                                        aria-label="Question 8 Strongly Agree"
                                        feedback="You must select an option before submitting."
                                        feedbackType="invalid"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q8-agree"
                                        value={3}
                                        name="q8"
                                        checked={q8Response === 3}
                                        onChange={(e: any) => setQ8Response(Number(e.target.value))}
                                        aria-label="Question 8 Agree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q8-disagree"
                                        value={2}
                                        name="q8"
                                        checked={q8Response === 2}
                                        onChange={(e: any) => setQ8Response(Number(e.target.value))}
                                        aria-label="Question 8 Disagree"
                                    />
                                </td>
                                <td className='text-center'>
                                    <Form.Check
                                        required
                                        type="radio"
                                        id="q8-strongly-disagree"
                                        value={1}
                                        name="q8"
                                        checked={q8Response === 1}
                                        onChange={(e: any) => setQ8Response(Number(e.target.value))}
                                        aria-label="Question 8 Strongly Disagree"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
                <div style={{ padding: "2em 1.5em", backgroundColor: "white", borderRadius: "0.5em", marginBottom: "1.5em" }}>
                    <Form.Group className="mb-4" controlId="q9">
                        <Form.Label>What did you like most about this training?</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            value={shortResponse1}
                            onChange={(e: any) => {
                                setShortResponse1(e.target.value);
                            }}
                        />

                    </Form.Group>
                    <Form.Group className="mb-4" controlId="q10">
                        <Form.Label>What did you like least about this training?</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            value={shortResponse2}
                            onChange={(e: any) => {
                                setShortResponse2(e.target.value);
                            }}
                        />
                    </Form.Group>

                    <Form.Group className="mb-4" controlId="q11">
                        <Form.Label>What, if anything, would you add, delete, or change about this class?</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            value={shortResponse3}
                            onChange={(e: any) => {
                                setShortResponse3(e.target.value);
                            }}
                        />
                    </Form.Group>

                    <Form.Group className="mb-4" controlId="q12">
                        <Form.Label>Do you have specific suggestions for improvement? If so, please elaborate.</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            value={shortResponse4}
                            onChange={(e: any) => {
                                setShortResponse4(e.target.value);
                            }}
                        />
                    </Form.Group>

                    <Form.Group controlId="q13">
                        <Form.Label>Other Comments</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            value={shortResponse5}
                            onChange={(e: any) => {
                                setShortResponse5(e.target.value);
                            }}
                        />
                    </Form.Group>
                    
                </div>
                <div className="d-flex gap-3 align-items-center" style={{ padding: "1.5em", backgroundColor: "white", borderRadius: "0.5em"}}>
                    <Button variant="primary" className="text-light" type="submit">Submit</Button>
                    {isLoading &&
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    }
                    {!isLoading &&
                        <div className='text-danger'>
                            {errMsg}
                        </div>
                    }
                </div>
            </Form>
        </div>
    );
};